module.exports = __webpack_public_path__ + "img/nav-bar.c02694c0.svg";